import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';

import { OptionHeading, SliderWrapper } from '../../styles';

const marks = {
  0: 'Fainter',
  50: 'Default',
  100: 'Stronger',
};

const HeatmapVisibility = ({ heatmapVisibility = 50, onChangeVisibility }) => (
  <>
    <OptionHeading>Heatmap Visibility</OptionHeading>
    <p>
      Adjust how visible lower-density areas are. Lower values keep sparse areas subtle.
      Higher values make weaker patterns easier to see.
    </p>
    <SliderWrapper>
      <Slider
        min={0}
        max={100}
        step={10}
        marks={marks}
        value={heatmapVisibility}
        onChange={onChangeVisibility}
      />
    </SliderWrapper>
  </>
);

HeatmapVisibility.propTypes = {
  heatmapVisibility: PropTypes.number,
  onChangeVisibility: PropTypes.func.isRequired,
};

export default HeatmapVisibility;
